import { render, staticRenderFns } from "./aboutList.vue?vue&type=template&id=3c864bc2&scoped=true&"
import script from "./aboutList.vue?vue&type=script&lang=js&"
export * from "./aboutList.vue?vue&type=script&lang=js&"
import style0 from "./aboutList.vue?vue&type=style&index=0&id=3c864bc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c864bc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c864bc2')) {
      api.createRecord('3c864bc2', component.options)
    } else {
      api.reload('3c864bc2', component.options)
    }
    module.hot.accept("./aboutList.vue?vue&type=template&id=3c864bc2&scoped=true&", function () {
      api.rerender('3c864bc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/about/aboutList.vue"
export default component.exports